import script from "./entries-table-cell.vue?vue&type=script&setup=true&lang=ts"
export * from "./entries-table-cell.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__